import { ThreeDots } from 'react-loader-spinner'
import { down } from 'styled-breakpoints'
import styled, { css, useTheme } from 'styled-components'
import ripple from '../../styles/animations/ripple'

const LoadingComp: React.FunctionComponent = () => {
  const theme: any = useTheme()
  return (
    <ThreeDots
      wrapperStyle={{ justifyContent: 'center' }}
      color={theme.colors.primary}
      width={100}
      height={30}
    />
  )
}

export const LoaderComponent = styled(LoadingComp)<any>`
  svg {
    margin: auto !important;
  }
`
export const Content = styled.div`
  overflow-y: hidden;
  overflow-x: hidden;
  max-width: 100%;
  display: block;
  background-color: #ffffff;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05);
`
export const TableGrid = styled.table`
  border-collapse: collapse;
  width: 100%;
  table-layout: auto;
  width: 100%;
  ${down('md')} {
    table-layout: fixed;
    margin: 0;
    border: 0;
  }
`

export const Tbody = styled.tbody`
  border-collapse: collapse;
`
export const Tr = styled.tr<{ $isEven?: boolean }>`
  border-bottom: 1px solid #f1f5f9;
  background-color: ${({ $isEven }) => ($isEven ? '#ffffff' : '#f8fafc')};
  transition: background-color 0.15s ease-in-out;

  &:hover {
    background-color: #f1f5f9;
  }

  ${down('md')} {
    display: block;
    border-radius: 8px;
    margin-bottom: 10px;
    border: 1px solid #e2e8f0;
  }
  &:last-child {
    text-align: right;
    justify-content: flex-end;
  }
`

export const Th = styled.th`
  padding: 14px 16px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #475569;
  background: #f8fafc;
  border-bottom: 2px solid #e2e8f0;
  text-align: left;
  ${down('md')} {
    border: none;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }
  &:last-child {
    text-align: right;
    justify-content: flex-end;
    display: flex;
    text-align: left;
    margin-left: auto;
  }
`

export const HeaderTable = styled.div`
  padding: 16px 20px;
  display: flex;
  gap: 15px;
  align-items: center;
  border-bottom: 1px solid #e2e8f0;
  background: #ffffff;
  justify-content: space-between;
  ${down('md')} {
    flex-direction: column;
  }
`

export const TitleTable = styled.h1`
  font-size: 18px;
  font-weight: 700;
  color: #0f172a;
`

export const LeftContent = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  flex-direction: row;
  width: 100%;
  max-width: 400px;
`
export const ButtonCreate = styled.div`
  ${ripple}
  cursor: pointer;
  align-items: center;
  display: flex;
  overflow: visible;
  img {
    width: 47px;
    height: 47px;
  }
`

export const Td = styled.td<{ active: boolean; $onOpenRow: boolean }>`
  padding: 14px 16px;
  white-space: pre-wrap;
  text-align: left;
  font-size: 13.5px;
  font-weight: 500;
  color: #1e293b;

  ${({ active }) => !active && `opacity: 0.5;`}

  ${({ $onOpenRow }) =>
    $onOpenRow &&
    css`
      cursor: pointer;
    `}


  &:last-child {
    text-align: end;
  }

  ${down('md')} {
    display: block;

    &:before {
      content: attr(data-label);
      float: left;
      font-weight: 500;
      margin-right: 10px;
      vertical-align: middle;
    }
    &:last-child {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
    }
  }
`

export const HeaderTableRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 15px;
  align-items: center;
`

export const SortContent = styled.div`
  display: flex;
  flex-direction: column;
  cursor: pointer;
  gap: 0px;
`

export const HeaderMobile = styled.div`
  display: none;
  color: #0f172a;

  ${down('md')} {
    display: flex;
    margin-bottom: 5px;
    font-weight: bold;
  }
`

export const Thead = styled.thead``
export const Empty = styled.div`
  display: flex;
  width: 100%;
  color: #64748b !important;
  font-weight: 500;
  text-transform: uppercase;
  justify-content: center;
  padding: 30px;
`
